import React from 'react';
import { services } from '../mock';
import { Button } from '../components/ui/button';

export default function Services() {
  return (
    <section id="services" className="relative py-24 md:py-32">
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        {/* Left column */}
        <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
          <div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-violet-300/70 uppercase mb-6">
            <span className="h-px w-10 bg-violet-400/50" />
            <span>Services</span>
          </div>
          <h2 className="font-display text-6xl md:text-7xl leading-[0.9] mb-8">
            <span className="block text-white">WHAT</span>
            <span className="block text-white">YKAS</span>
            <span className="block text-gradient-purple italic">BRINGS</span>
          </h2>
          <p className="text-white/60 mb-8 leading-relaxed max-w-sm">
            Every performance is tailored to your brief, your crowd, your vibe. No cookie-cutter playlists. No two sets are the same.
          </p>
          <Button asChild className="bg-violet-400 text-[#1a0b2e] hover:bg-violet-300 rounded-none font-mono text-[11px] tracking-[0.25em] uppercase h-12 px-8">
            <a href="#cta">Get a Quote</a>
          </Button>
        </div>

        {/* Right column - service cards */}
        <div className="lg:col-span-8 space-y-3">
          {services.map((s) => (
            <div key={s.num} className="card-glow group grid grid-cols-[auto_1fr_auto] gap-6 items-start p-6 md:p-8 rounded-md border border-violet-500/15 bg-gradient-to-r from-violet-950/25 to-transparent">
              <div className="font-mono text-xs tracking-[0.25em] text-violet-300/60 pt-1">{s.num}</div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl text-white mb-2 tracking-wide">{s.title}</h3>
                <p className="text-sm text-white/55 leading-relaxed max-w-xl">{s.desc}</p>
              </div>
              <div className="text-right pl-4">
                <div className="font-mono text-[10px] tracking-[0.25em] text-white/40 uppercase">{s.from}</div>
                <div className="font-display text-4xl md:text-5xl text-gradient-purple mt-1">{s.price}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
